export default {
    getsectors: state => {
        return state.VotreProject.Sectors.filter(item => item.parent === null);
    },
    getSubSectors: state => id => {
        return state.VotreProject.Sectors.filter(item => item.parent === id);
    },
    getSteps: (state, getters, rootState) => {
        if (rootState.user.bpiVersion === "Version Simplifiée")
            return state.simpleVersionSteps;
        return state.steps;
    }
};
